import { securityRoleGrpSteps } from "./Rolegroups.tsx";
import { groupAssoUsersSteps, groupDetailsEditStep, groupRolesEditSteps, } from "./Edit.tsx";
import { groupDetailsStep, groupRolesSteps } from "./Create.tsx"; 
/**
 * Dynamically return the appropriate Joyride steps based on the path and query params
 * @param {string} path - current URL pathname
 * @param {URLSearchParams} query - query object (new URLSearchParams(location.search))
 * @returns {Array} steps - Joyride steps
 */

export const getRolegrpsJoyrideSteps = (path, query, activeTab) => {

  if (path === "/rolegroups") {
    return securityRoleGrpSteps;
  }

  if (path === "/rolegroups/edit") {
    const id = query.get("id");

    if (id === "0") {
      // Create mode
      if (activeTab === "details") return groupDetailsStep;
      if (activeTab === "roles") return groupRolesSteps;
      return [];
    }

    if (id && id !== "0") {
      // Edit mode
      if (activeTab === "details") return groupDetailsEditStep;
      if (activeTab === "roles") return groupRolesEditSteps;
      if (activeTab === "users") return groupAssoUsersSteps;
      return [];
    }
  }

  return [];
};